import { SitemapItem } from './sitemap-item'

export class CustomItem extends SitemapItem {
  public name: string

  constructor(model: CustomItem) {
    super(model)
    this.name = model.name
  }
}
